import { React, useEffect, useState } from "react";
import "../../../../assets/CreditAnalyse/css/FLpLoaderOtp.scss";
import "../../../../assets/CreditAnalyse/css/custom.scss";
import tmsLogo from "../../../../assets/CreditAnalyse/img/tms-legal-logo.png";
import welcomeBack from "../../../../assets/CreditAnalyse/img/welcome-back.png";
import FO from "../../../../assets/CreditAnalyse/img/financia_ombudsman.png";
import btnLoader from "../../../../assets/UFC_DC_V1/img/buttonLoader.gif";

const LoaderFlp = ({ showLoad, handleSubmit, btnDisabled, loader }) => {
  
  // timer countdown
  // useEffect(() => {
  //   const cLoaderWrapEl = document.querySelector(".cLoaderWrap");
  //   if (!cLoaderWrapEl) return;

  //   const cPathEl = cLoaderWrapEl.querySelector(".cPath");
  //   const cLoaderEl = cLoaderWrapEl.querySelector(".cLoader");
  //   const cCountEl = cLoaderWrapEl.querySelector(".cCount");
  //   const cLoadedEl = cLoaderWrapEl.querySelector(".cLoaded");

  //   function timer(sec = 5) {
  //     const timeLength = sec;

  //     const updateTimerHTML = () => {
  //       cCountEl.classList.add("zoom");
  //       cCountEl.innerHTML = formatNumber(sec);
  //       setTimeout(() => {
  //         if (sec !== 1) {
  //           cCountEl.classList.remove("zoom");
  //         }
  //       }, 800);
  //     };

  //     const t = () => {
  //       if (sec > 1) {
  //         sec--;
  //         updateTimerHTML();
  //         setTimeout(t, 1000);
  //       } else {
  //         cLoadedEl.classList.add("zoom");
  //         cLoaderEl.classList.add("done");
  //       }
  //     };

  //     let spinnerValue = timeLength * 100;
  //     const spinnerT = setInterval(() => {
  //       if (sec > 1) {
  //         spinnerValue -= 12.5;
  //         cLoaderEl.style.strokeDashoffset =
  //           (440 / (timeLength * 100)) * spinnerValue;
  //       } else {
  //         clearInterval(spinnerT);
  //       }
  //     }, 100);

  //     updateTimerHTML();
  //     setTimeout(t, 1000);
  //   }

  //   function formatNumber(n) {
  //     return n >= 10 ? n : "0" + n;
  //   }

  //   timer(5);
  // }, []);

  return (
    <div className={`FLPLoaderOTP ${showLoad}`}>
      <section className="otp-section">
        <div className="container">
          <div className="brand">
            <div className="logo pt-4 mb-5">
              <a>
                <img src={tmsLogo} height={60} alt />
              </a>
            </div>
          </div>
        </div>
        <div className="container ">
          <div className="row justify-content-md-center">
            <div className="col-lg-8">
              <div className="card w-100 otp-card screen3  all-screen p-4">
                <div className="card-body text-white welcome">
                  <img src={FO} className="mb-3" height={60} alt="" />
                  <h2 className="text-center">Urgent!</h2>
                  {/* <h4>Fname Lname</h4> */}
                  <p className="text-center">
                    The Ombudsman require supporting evidence, such as your
                    credit report, for your unaffordable lending claim. Please
                    note they may refuse to investigate your case unless we
                    provide supporting evidence.{" "}
                  </p>
                  <p>
                    It's very quick and easy for you to give us permission to
                    access your credit report to pass to the Ombudsman.
                  </p>
                  <div className="form-group mb-2">
                    {/* <button
                      disabled={btnDisabled}
                      className="otp-verify-btn"
                      id="verify-otp"
                      onClick={handleSubmit}
                    >
                      Continue {">"}
                    </button> */}
                    {!loader && (
                      <button
                        className={`otp-verify-btn`}
                        id="verify-otp"
                        type="button"
                        onClick={handleSubmit}
                      >
                        <span>Continue{">"}</span>{" "}
                      </button>
                    )}
                    {!!loader && (
                      <button
                        className={`otp-verify-btn`}
                        id="verify-otp"
                        type="button"
                        disabled={btnDisabled}
                      >
                        <span>
                          <img src={btnLoader} alt="loading..." />
                        </span>
                      </button>
                    )}
                  </div>
                  {/* <div className>
                    <div className="row counter-loader"><div className="col-12"><div className="cLoaderWrap">
                      <svg id="cLoaderSVG" width={120} height={120} xmlns="http://www.w3.org/2000/svg">
                        <circle className="cPath" r={70} cy={100} cx={100} />
                        <circle className="cLoader" r={70} cy={100} cx={100} />
                      </svg>
                      <i className=" cLoaded zoo " />
                      <b className="cCount">05</b>
                    </div></div></div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoaderFlp;
